
import AssessmentSettingSelectField from "@/components/settings/assessment/AssessmentSettingSelectField.vue";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";
import {
  GET_COMPANY_DETAILS,
  SET_COMPANY
} from "@/store/modules/auth/constants";
import { APP_ASSESSMENTS } from "@/store/modules/common/constants";
import { AppAssessmentNames } from "@/store/modules/common/interfaces";
import {
  INCEPTION_STATS,
  UPDATE_COMPANY_SETTING
} from "@/store/modules/recruiter/constants";
import {
  CompanySettingTypes,
  UpdateCompanySettingPayload
} from "@/store/modules/recruiter/interfaces";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default Vue.extend({
  components: { AssessmentSettingSelectField, GoBackHeader },
  name: "AssessmentsSetting",
  data() {
    return {
      candidate_eng: "",
      candidate_annotation: "",
      candidate_default_assessments: [] as string[],
      additional_assessment_items: [] as { title: string; value: string }[],
      admin_eng: "",
      admin_annotation: "",
      eng_assessment_items: [
        {
          title: "English V1",
          value: "english_v1"
        },
        {
          title: "English V2",
          value: "english_v2"
        },
        {
          title: "English V3",
          value: "english_v3"
        },
        {
          title: "English V4",
          value: "english_v4"
        },
        {
          title: "English V5",
          value: "english_v5"
        },
        {
          title: "English GENx Easy V1",
          value: "english_genx_easy_v1"
        },
        {
          title: "English GENx Medium V1",
          value: "english_genx_medium_v1"
        },
        {
          title: "English Technician V1",
          value: "english_technician_v1"
        },
        {
          title: "English Lead Technician V1",
          value: "english_lead_technician_v1"
        },
        {
          title: "English Assistant Engineer V1",
          value: "english_assistant_engineer_v1"
        }
      ],
      annotation_assessment_items: [
        {
          title: "Annotation V1",
          value: "annotation_v1"
        },
        {
          title: "Annotation V2",
          value: "annotation_v2"
        },
        {
          title: "Annotation V3",
          value: "annotation_v3"
        }
      ],
      candidate_default_assessment_items_base: []
    };
  },
  async created() {
    await this.fetch_app_assessments();
    this.additional_assessment_items = this.get_additional_assessment_items();
    const assessment_setting =
      this.get_company_details?.storage_path?.assessment_setting;
    this.candidate_eng = assessment_setting?.candidates_english;
    this.candidate_annotation = assessment_setting?.candidates_annotation;
    this.candidate_default_assessments = this.parse_default_assessments(
      assessment_setting?.candidates_default_assessments
    );
    this.admin_eng = assessment_setting?.admin_english;
    this.admin_annotation = assessment_setting?.admin_annotation;
  },
  computed: {
    ...mapGetters("auth", {
      get_company_details: GET_COMPANY_DETAILS
    }),
    ...mapGetters("common", {
      app_assessments: APP_ASSESSMENTS
    }),
    candidate_default_assessment_items(): { title: string; value: string }[] {
      return [
        ...this.candidate_default_assessment_items_base,
        ...this.additional_assessment_items
      ];
    },
    AppAssessments() {
      return AppAssessments;
    }
  },
  methods: {
    ...mapActions("common", {
      fetch_app_assessments: APP_ASSESSMENTS
    }),
    ...mapActions("recruiter", {
      update_company_setting: UPDATE_COMPANY_SETTING
    }),
    ...mapMutations({
      set_root_error: ROOT_ERROR,
      set_root_notification: ROOT_NOTIFICATION
    }),
    ...mapMutations("recruiter", {
      set_inception_stats: INCEPTION_STATS
    }),
    ...mapMutations("auth", {
      set_company: SET_COMPANY
    }),
    // Function to update company assessment setting
    async update_value({
      type,
      value
    }: {
      type: AppAssessments.CurrentAssessmentType;
      value: AppAssessmentNames | string;
    }) {
      // API Call
      const payload: UpdateCompanySettingPayload = {
        current_assessment: value,
        current_assessment_type: type,
        type: CompanySettingTypes.ASSESSMENT_SETTING
      };
      const response = await this.update_company_setting(payload);
      if (response) {
        this.set_company(response);
        this.set_inception_stats({
          users: "0",
          englishAssessment: "0",
          annotationAssessment: "0"
        });
        this.set_root_notification(
          this.$t("recruiter.settings.assessment.update")
        );
      }
    },
    parse_default_assessments(setting_value?: string): string[] {
      const parsed = String(setting_value || "")
        .split(",")
        .map((item) => item.trim().toLowerCase())
        .filter((item) => item.startsWith("ai:"));
      return parsed;
    },
    get_additional_assessment_items(): { title: string; value: string }[] {
      // Keep only additional assessments (exclude built-in English/Annotation versions)
      const additional = (this.app_assessments || []).filter(
        (assessment: AppAssessments.Assessment) =>
          !String(assessment.assessment_type).startsWith("english_") &&
          !String(assessment.assessment_type).startsWith("annotation_")
      );
      return additional.map((assessment: AppAssessments.Assessment) => ({
        title: `Additional: ${assessment.assessment_name}`,
        value: `ai:${assessment.id}`
      }));
    },
    async update_default_assessments() {
      await this.update_value({
        type: AppAssessments.CurrentAssessmentType
          .CANDIDATE_DEFAULT_ASSESSMENTS,
        value: this.candidate_default_assessments.join(",")
      });
    }
  }
});
